import { dimens } from '@/shahrzad-assets/shared-constants/dimens'
import { buttonTypes } from '@/shahrzad-assets/shared-constants/buttonTypes'
import { colors } from '@/shahrzad-assets/shared-constants/colors'
import CustomDatepicker from '@/UI/CustomDatepicker'
import { getDateAndTime } from '@/shahrzad-assets/shared-utils/getDateAndTime'
import CustomButton from '@/shahrzad-assets/shared_components/CustomButton'
import Input from '@/shahrzad-assets/shared_components/Input'
import { OtpContext } from '@/shahrzad-assets/shared-hooks/OtpContext'
import { useFormik } from 'formik'
import * as yup from 'yup'
import useSignupLegalUser from '@/hooks/useSignupLegalUser'
import { CSelect } from '@/shahrzad-assets/shared_components/CSelect'
import styled from 'styled-components'
import { Checkbox } from 'antd'
import React, { useContext, useMemo, useState } from 'react'
import { persianNumConverter } from '@/shahrzad-assets/shared-utils/persianNumConverter'

const LegalForm = () => {
  const { setUserPhoneNumber } = useContext(OtpContext)
  const [hasNationalId, setHasNationalId] = useState(true)

  const fields = useMemo(() => {
    const formFields = [
      {
        name: 'name',
        label: 'نام شرکت',
        type: 'text',
        validation: yup.string().required('اجباری است'),
      },
      {
        name: 'regNo',
        label: 'شماره ثبت',
        type: 'text',
        validation: yup.string().required('اجباری است'),
      },
      {
        name: 'address',
        label: 'نشانی شرکت',
        type: 'text',
        validation: yup.string().required('اجباری است'),
      },
      {
        name: 'activityTypeId',
        label: 'نشانی شرکت',
        type: 'text',
        Component: CSelect,
        props: {
          label: 'نوع شرکت',
          options: [
            { label: 'خدماتی', value: 1 },
            { label: 'اقتصادی', value: 2 },
            { label: 'صنعتی', value: 3 },
            { label: 'کشاورزی', value: 4 },
            { label: 'تولیدی', value: 5 },
          ],
        },
        validation: yup.number().min(1).max(5),
      },
      {
        name: 'econamicCode',
        label: 'کد اقتصادی',
        type: 'number',
        validation: yup
          .string()
          .required('اجباری است')
          .test(
            'نامعتبر است',
            'کد اقتصادی باید 11 یا 12 رقم باشد',
            (value) => value && (value.length === 11 || value.length === 12),
          ),
      },
      {
        name: 'managerName',
        label: 'نام و نام‌خانوادگی بالاترین مقام مسئول',
        type: 'text',
        validation: yup.string().required('اجباری است'),
      },
      {
        name: 'managerNCode',
        label: 'کد ملی بالاترین مقام مسئول',
        type: 'number',
        validation: yup
          .string()
          .required('لطفاً کدملی را وارد کنید')
          .length(10, 'کد ملی باید 10 رقم باشد'),
      },
      {
        name: 'cellPhone',
        label: 'شماره موبایل',
        type: 'number',
        validation: yup
          .string()
          .required('لطفاً شماره موبایل را وارد کنید')
          .matches(/^09[0-9]*$/, 'فرمت شماره موبایل صحیح نیست')
          .length(11, 'شماره موبایل باید 11 رقم باشد'),
      },
    ]
    if (hasNationalId) {
      const newField = {
        name: 'nationalId',
        label: 'شناسه ملی',
        type: 'number',
        validation: yup
          .string()
          .required('شناسه را وارد کنید')
          .length(11, 'شناسه 11 رقم است'),
      }
      formFields.unshift(newField)
    }
    return formFields
  }, [hasNationalId])

  const shape = useMemo(() => {
    const res = {}
    fields.forEach((field) => {
      res[field.name] = field.validation
    })
    return res
  }, [fields])

  // const shape = useMemo(() => {
  //   const res = {}
  //   fields.map(
  //     (field) =>
  //       (res[field.name] =
  //         field.validation ||
  //         yup.string().required(generateErrorMessage(field.label))),
  //   )
  //   if (hasNationalId) {
  //     res['nationalId'] = yup.number().min(1).max(5)
  //   }
  //   return res
  // }, [hasNationalId])

  const { fetchSignupLegalUser, signupLoading } = useSignupLegalUser()

  const initialValues = {
    name: '',
  }

  const validationSchema = yup.object().shape(shape)

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema,
    validateOnChange: true,
    enableReinitialize: true,
    onSubmit: (values) => {
      setUserPhoneNumber(values.cellPhone)
      fetchSignupLegalUser({
        ...values,
        hasNationalId: hasNationalId,
        nationalId: +values.nationalId ? +values.nationalId : 0,
        persianRegDate: persianNumConverter(values?.persianRegDate),
        phone: values.cellPhone,
      })
    },
  })

  const inputSetter = (field: any) => {
    return (value: any) => {
      formik.setFieldValue(field, value)
    }
  }

  const toggleHasNationalId = () => setHasNationalId(!hasNationalId)

  return (
    <>
      <FieldContainer onClick={toggleHasNationalId}>
        <Checkbox
          checked={!hasNationalId}
          onChange={toggleHasNationalId}
        />
        <label style={{ paddingRight: '6px' }}>فاقد شناسه ملی</label>
      </FieldContainer>
      <form onSubmit={formik.handleSubmit}>
        {fields.map((field) =>
          field.Component ? (
            <field.Component
              {...formik.getFieldProps(field.name)}
              onChange={inputSetter(field.name)}
              error={formik.touched[field.name] && formik.errors[field.name]}
              errorText={formik.errors[field.name]}
              {...field.props}
            />
          ) : (
            <Input
              key={field.name}
              type={field.type}
              id={field.name}
              label={field.label}
              {...formik.getFieldProps(field.name)}
              onChange={inputSetter(field.name)}
              error={formik.touched[field.name] && formik.errors[field.name]}
              errorText={formik.errors[field.name]}
            />
          ),
        )}
        {/* <CustomDatepicker  /> */}
        <CustomDatepicker
          label='تاریخ ثبت شرکت'
          placeholder=''
          onChange={(val) =>
            formik.setFieldValue('persianRegDate', getDateAndTime(val).date)
          }
        />
        <SubmitButton
          width='100%'
          height={dimens.BUTTON_LARGE_HEGHIT}
          styletype={buttonTypes.PRIMARY_FILL}
          icon='go'
          loading={signupLoading}
          disabled={!formik.isValid || !formik.dirty}
          htmlType='submit'
        >
          ثبت نام
        </SubmitButton>
      </form>
    </>
  )
}

export default LegalForm

const SubmitButton = styled(CustomButton)`
  margin-top: ${dimens.SPACING_S};
`
const FieldContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${dimens.SPACING_XXS};
  margin-bottom: ${dimens.SPACING_M};
  border-radius: ${dimens.BORDER_RADIUS_4};
  border: solid ${dimens.BORDER_WIDTH_THIN}
    ${(props) => (props.error ? colors.criticalStroke : colors.stroke2)};

  background-color: ${colors.bg2};
  color: ${colors.text1};
  padding: ${dimens.SPACING_S};
  text-align: ${(props) => props.alignCenter && 'center'};
  box-shadow: none;
  &:hover {
    background-color: ${(props) =>
      props.error ? colors.bg2 : colors.bg2Hover};
    border-color: ${(props) =>
      props.error ? colors.criticalStroke3 : colors.stroke3};
  }
  &:focus {
    background-color: ${colors.bg2};
    border-color: ${(props) =>
      props.error ? colors.criticalStroke3 : colors.primaryBrandStroke};

    &:hover {
      background-color: ${colors.bg2Hover};
      border-color: ${(props) =>
        props.error ? colors.criticalStroke3 : colors.primaryBrandStrokeHover};
    }
  }
  .ant-checkbox-inner {
    border-radius: ${dimens.BORDER_RADIUS_4} !important;
    overflow: hidden;
  }
  .ant-checkbox-checked::after {
    border: none;
  }
  .ant-checkbox-checked:hover .ant-checkbox-inner {
    background-color: ${colors.primaryBrandBgHover} !important;
  }
  .ant-checkbox-checked:active .ant-checkbox-inner {
    background-color: ${colors.primaryBrandBgPress} !important;
  }

  label {
    cursor: pointer;
  }
`
